import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSites = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M18.75 11.828a1 1 0 0 1 1-1H21a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1.25a1 1 0 0 1-1-1v-7Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M8.287 4.215A1 1 0 0 0 7 5.173v5.905h2a2.75 2.75 0 0 1 2.75 2.75v5.001a1 1 0 0 0 1 1H16a1 1 0 0 0 1-1V7.572a1 1 0 0 0-.713-.958l-8-2.4Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M10 13.828a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5H9a1 1 0 0 0 1-1v-5Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcSites");

export { IcSites };
//# sourceMappingURL=ic-sites.js.map
